module.exports = __webpack_public_path__ + "pic4.3b300052f83fac2c5849.jpg";


//////////////////
// WEBPACK FOOTER
// /home/alinu/Alin/Work/Workspace/BART-client/src/assets/img/pic4.jpg
// module id = ../../../../../src/assets/img/pic4.jpg
// module chunks = main